/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-app-switcher': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15.5 15.5H18V18h-2.5v-2.5zm-6.75 0h2.5V18h-2.5v-2.5zM2 15.5h2.5V18H2v-2.5zm13.5-6.75H18v2.5h-2.5v-2.5zm-6.75 0h2.5v2.5h-2.5v-2.5zM2 8.75h2.5v2.5H2v-2.5zM15.5 2H18v2.5h-2.5V2zM8.75 2h2.5v2.5h-2.5V2zM2 2h2.5v2.5H2V2z"/>'
  }
})
